import VueRouter from 'vue-router';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { utils } from '@easygenerator/fragment-sdk';
import { LoggingType } from '@easygenerator/fragment-sdk/dist/utils/logger/constants';
import Config from './config';

class SentryService {
  async initialize(router: VueRouter) {
    if (!this.isSentryEnabled()) {
      return;
    }
    const {
      dsn,
      environment,
      tracesSampleRate,
      tracePropagationTargets,
      replaysSessionSampleRate,
      replaysOnErrorSampleRate
    } = Config.getInstance().sentry;
    if (!dsn) {
      const logger = utils.Logger.getInstance();
      logger.trackError(LoggingType.error,
        '[Sentry] Sentry misconfiguration error. Update environment configuration to enable Sentry');
      return;
    }

    Sentry.init({
      Vue,
      dsn,
      environment,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate,
      tracePropagationTargets,
      replaysSessionSampleRate,
      replaysOnErrorSampleRate
    });
  }

  private isSentryEnabled() {
    return !window.Cypress;
  }
}

export default new SentryService();
